export enum NotViewedFilterDefaultData {
  dayNumber = 30,
  minDayLength = 1,
  maxDayLength = 3,
  maxDayNumber = 999,
  includeType = 'none',
  executantType = 'me'
}
